import styled from 'styled-components'
import { Link, NavLink } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { paddingW } from '../constants';

const Navbar = () => {
  const color = useSelector(state => state.colorSlice.value);
  return (
    <Container>
      <Logo to="/" color={color}>Mahmoud <span>N.</span> | IMX</Logo>
      <Links>
        <SNavLink to="/" color={color}>Home</SNavLink>
        <SNavLink to="/about" color={color}>About</SNavLink>
        <SNavLink to="/work" color={color}>Work</SNavLink>
        <SNavLink to="/contact" color={color}>Contact</SNavLink>
      </Links>
    </Container>
  )
}

export default Navbar;

const Container = styled.nav`
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 1;
  @media screen and (max-width: 500px) {justify-content: center;}
  position: fixed;
  width: calc(100% - ${paddingW} * 2);
`;
const Logo = styled(Link)`
  font-size: 1.5rem;
  font-weight: 500;
  span {
    color: ${props => props.color};
  }
`;
const Links = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  column-gap: 1rem;
  @media screen and (max-width: 500px) {display: none;}
`;
const SNavLink = styled(NavLink)`
  font-size: 1rem;
  position: relative;
  &::after {
    content: '';
    display: block;
    width: 0;
    height: 2px;
    border-radius: 1rem;
    background-color: ${props => props.color};
    position: absolute;
    bottom: 0;
    transition: background-color 0.1s ease-in-out;
  }
  &.active::after {
    width: 100%;
  }
`;